// [SC] - 9th Mar 2026 - for accessibility


// For click trigger on corresponding link of the same feature row
const sc_feature_images = document.querySelectorAll('.feature-row:has(a.btn) .feature-row__images img');
sc_feature_images.forEach(img => {
  img.style.cursor = 'pointer';
  img.addEventListener('click', () => {
    const parentRow = img.closest('.feature-row');
    const targetBtn = parentRow?.querySelector('a.btn');
    
    if (targetBtn) {
      targetBtn.click();
    }
  });
});






function handlePredictiveSearchFocus(event) {
  // Get all predictive search elements on the page
  const predictiveSearches = document.querySelectorAll('predictive-search');
  
  predictiveSearches.forEach(predictiveSearch => {
    if (!predictiveSearch || !predictiveSearch.classList.contains('is-active')) {
      return;
    }
    
    const activeElement = document.activeElement;
    const isFocusWithin = predictiveSearch.contains(activeElement);
    
    if (!isFocusWithin) {
      // Find the predictive-search-results element inside
      const searchResults = predictiveSearch.querySelector('#predictive-search');
      
      if (searchResults) {
        // Clear the HTML content
        searchResults.innerHTML = '';
        // Add display none style
        searchResults.style.display = 'none';
        
        // Optional: Also remove any existing visibility classes or styles
        searchResults.classList.remove('visible', 'active', 'show');
      }
      
      // Remove the is-active class after clearing results
      predictiveSearch.classList.remove('is-active');
    }
  });
}

function handlePredictiveSearchClick(event) {
  // Small delay to allow focus to update before checking
  setTimeout(() => handlePredictiveSearchFocus(event), 0);
}

function handlePredictiveSearchEscape(event) {
  if (event.key === 'Escape') {
    const predictiveSearches = document.querySelectorAll('predictive-search');
    
    predictiveSearches.forEach(predictiveSearch => {
      if (predictiveSearch && predictiveSearch.classList.contains('is-active')) {
        const searchResults = predictiveSearch.querySelector('#predictive-search');
        if (searchResults) {
          searchResults.innerHTML = '';
          searchResults.style.display = 'none';
        }
        predictiveSearch.classList.remove('is-active');
      }
    });
  }
}

// Listen for both focus changes and clicks
document.addEventListener('focusin', handlePredictiveSearchFocus);
document.addEventListener('click', handlePredictiveSearchClick);

// Handle ESC key to close predictive search
document.addEventListener('keydown', handlePredictiveSearchEscape);









//removing unwanted aria from app generated content for WAVE tool accessibility validation
(function () {
  function cleanAriaRole(el) {
    if (el.nodeType !== 1) return;
    if (el.hasAttribute && el.hasAttribute('aria-role') && el.hasAttribute('role')) {
      el.removeAttribute('aria-role');
    }
    // Also check its children
    if (el.querySelectorAll) {
      el.querySelectorAll('[aria-role][role]').forEach(function(node) {
        node.removeAttribute('aria-role');
      });
    }
  }
  // Initial cleanup
  document.querySelectorAll('[aria-role][role]').forEach(function(el){
    el.removeAttribute('aria-role');
  });
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // New nodes added
      mutation.addedNodes.forEach(function(node) {
        cleanAriaRole(node);
      });
      // Attribute changes
      if (mutation.type === 'attributes') {
        cleanAriaRole(mutation.target);
      }
    });
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-role','role']
  });
})();








(function() {
  function applyAccessibilityChanges() {
    var reviewSection = document.querySelector('.oke-reviewCarousel-reviews');
    if (!reviewSection) return false;

    var changed = false;

    // Add tabindex="-1" and aria-hidden="true" to all <a> tags
    var links = reviewSection.querySelectorAll('a');
    links.forEach(function(link) {
      if (link.getAttribute('tabindex') !== '-1') {
        link.setAttribute('tabindex', '-1');
        changed = true;
      }
      if (link.getAttribute('aria-hidden') !== 'true') {
        link.setAttribute('aria-hidden', 'true');
        changed = true;
      }
    });

    // Add tabindex="-1" and aria-hidden="true" to all buttons
    var buttons = reviewSection.querySelectorAll('button');
    buttons.forEach(function(button) {
      if (button.getAttribute('tabindex') !== '-1') {
        button.setAttribute('tabindex', '-1');
        changed = true;
      }
      if (button.getAttribute('aria-hidden') !== 'true') {
        button.setAttribute('aria-hidden', 'true');
        changed = true;
      }
    });

    // Add aria-hidden="true" to all images
    var images = reviewSection.querySelectorAll('img');
    images.forEach(function(img) {
      if (img.getAttribute('aria-hidden') !== 'true') {
        img.setAttribute('aria-hidden', 'true');
        changed = true;
      }
    });

    return changed;
  }

  // Try immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      applyAccessibilityChanges();
    });
  } else {
    applyAccessibilityChanges();
  }

  // Retry periodically for lazy-loaded content (safe fallback)
  var retryInterval = setInterval(function() {
    var changed = applyAccessibilityChanges();
    // If we found and updated the section, we could stop after a few seconds
    // but keep going in case content inside changes
  }, 1000);

  // Stop retrying after 30 seconds to avoid infinite loop
  setTimeout(function() {
    clearInterval(retryInterval);
  }, 30000);

  // Also watch for DOM changes (more efficient than interval)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var shouldCheck = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          shouldCheck = true;
          break;
        }
      }
      if (shouldCheck) {
        applyAccessibilityChanges();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();















// for accessibiity of testimonail slider of review app
(function() {
  // Find the testimonials carousel
  const testimonialsCarousel = document.querySelector('div[data-oke-carousel][data-oke-header-text="Testimonials"]');
  
  if (!testimonialsCarousel) return;
  
  // Find the parent Shopify section
  const currentSection = testimonialsCarousel.closest('.shopify-section');
  
  if (!currentSection) return;
  
  // Find the next Shopify section
  let nextSection = currentSection.nextElementSibling;
  while (nextSection && !nextSection.matches('.shopify-section')) {
    nextSection = nextSection.nextElementSibling;
  }
  
  if (!nextSection) return;
  
  // Find the first focusable element in the next section
  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ];
  
  let focusableElement = null;
  for (const selector of focusableSelectors) {
    focusableElement = nextSection.querySelector(selector);
    if (focusableElement) break;
  }
  
  // Target is either the focusable element or the section itself
  const targetElement = focusableElement || nextSection;
  
  // Remove existing skip link if present
  const existingLink = currentSection.querySelector('.skip-to-next-section');
  if (existingLink) existingLink.remove();
  
  // Create skip link
  const skipLink = document.createElement('a');
  skipLink.href = `#${targetElement.id || (targetElement.id = 'skip-target-' + Date.now())}`;
  skipLink.className = 'skip-to-next-section';
  skipLink.textContent = 'Skip to next section';
  skipLink.setAttribute('aria-label', 'Skip testimonials and go to next section. Or browse multiple testimonials contained on the slider of this testimonial section');
  
  // Style the skip link (hidden until focused)
  skipLink.style.cssText = `
    position: absolute;
    left: -9999px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
    z-index: 9999;
  `;
  
  // Show on keyboard focus
  skipLink.addEventListener('focus', () => {
    skipLink.style.cssText = `
      position: fixed;
      left: 10px;
      top: 10px;
      width: auto;
      height: auto;
      padding: 10px 15px;
      background: white;
      color: black;
      border: 2px solid black;
      border-radius: 4px;
      text-decoration: none;
      font-weight: bold;
      z-index: 9999;
    `;
  });
  
  skipLink.addEventListener('blur', () => {
    skipLink.style.cssText = `
      position: absolute;
      left: -9999px;
      width: 1px;
      height: 1px;
      overflow: hidden;
      z-index: 9999;
    `;
  });
  
  // Handle click - focus on the target element
  skipLink.addEventListener('click', (e) => {
    e.preventDefault();
    const target = document.getElementById(targetElement.id);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  
  // Add skip link at the beginning of the current section
  currentSection.insertBefore(skipLink, currentSection.firstChild);
})();




















// to set tab-index="-1" and aria-hidden for all element of some app which cannot be accessible
function applyAttributesToAllDescendants(element) {
  if (!element) return;
  
  // Function to apply to a single node
  function applyToNode(node) {
    if (node.nodeType === 1) { // Element node
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('tabindex', '-1');
    }
  }
  
  // Apply to the parent
  applyToNode(element);
  
  // Apply to all existing descendants using TreeWalker
  const treeWalker = document.createTreeWalker(
    element,
    NodeFilter.SHOW_ELEMENT
  );
  
  let currentNode = treeWalker.nextNode();
  while (currentNode) {
    applyToNode(currentNode);
    currentNode = treeWalker.nextNode();
  }
  
  // Watch for ANY new nodes added anywhere inside this element in the future
  const descendantObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        // Apply to the added node
        if (node.nodeType === 1) {
          applyToNode(node);
          
          // Also apply to any descendants of the added node
          const subTreeWalker = document.createTreeWalker(
            node,
            NodeFilter.SHOW_ELEMENT
          );
          let subNode = subTreeWalker.nextNode();
          while (subNode) {
            applyToNode(subNode);
            subNode = subTreeWalker.nextNode();
          }
        }
      });
    });
  });
  
  descendantObserver.observe(element, {
    childList: true,
    subtree: true
  });
}

// Function to check and process a specific selector
function processSelector(selector, attributeName) {
  const element = document.querySelector(selector);
  if (element && !element.hasAttribute(attributeName)) {
    element.setAttribute(attributeName, 'true');
    applyAttributesToAllDescendants(element);
  }
}

// Main observer to find both parent elements
const observer = new MutationObserver((mutations, obs) => {
  // Check for first element
  processSelector('#oke-loyalty-earn .c-customisableEarningRules', 'data-processed-loyalty');
  
  // Check for second element
  processSelector('#insta-feed', 'data-processed-insta');
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Initial checks for both elements
const existingLoyaltyElement = document.querySelector('#oke-loyalty-earn .c-customisableEarningRules');
if (existingLoyaltyElement && !existingLoyaltyElement.hasAttribute('data-processed-loyalty')) {
  existingLoyaltyElement.setAttribute('data-processed-loyalty', 'true');
  applyAttributesToAllDescendants(existingLoyaltyElement);
}

const existingInstaElement = document.querySelector('#insta-feed');
if (existingInstaElement && !existingInstaElement.hasAttribute('data-processed-insta')) {
  existingInstaElement.setAttribute('data-processed-insta', 'true');
  applyAttributesToAllDescendants(existingInstaElement);
}







// To add alternative button for accessibiilty so it can be used in earn point app's generated content
function insertButton() {
  const targetElement = document.querySelector('#oke-loyalty-earn .c-customisableEarningRules');
  if (targetElement) {
    // Check if button already exists nearby
    const existingButton = targetElement.previousElementSibling;
    if (existingButton && existingButton.classList.contains('sc-earn-info-redirect')) {
      return;
    }
    
    const button = document.createElement('button');
    button.className = 'sc-earn-info-redirect';
    button.setAttribute('aria-label', 'Redirect to "Earn Points" page');
    button.textContent = 'Redirect button for accessibility user to see detail of "Earn Point"';
    button.style.marginBottom = '10px'; // Add some spacing
    
    // Add click event listener
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      // Find the target button inside #oke-loyalty-earn
      const targetButton = document.querySelector('#oke-loyalty-earn button.c-button--customisable');
      
      if (targetButton) {
        targetButton.click(); // Trigger the click event
      } else {
        // If not found, wait for it dynamically
        const observer = new MutationObserver((mutations, obs) => {
          const retryButton = document.querySelector('#oke-loyalty-earn button.c-button--customisable');
          if (retryButton) {
            retryButton.click();
            obs.disconnect();
          }
        });
        observer.observe(document.querySelector('#oke-loyalty-earn') || document.body, {
          childList: true,
          subtree: true
        });
        
        // Fallback timeout
        setTimeout(() => {
          observer.disconnect();
        }, 3000);
      }
    });
    targetElement.parentNode.insertBefore(button, targetElement);
  }
}
// Poll every 300ms
const intervalId = setInterval(insertButton, 300);
// Stop after 30 seconds
setTimeout(() => clearInterval(intervalId), 30000);












// added class 'using-mouse' for outline and other accessibility uses
function initUsingMouse() {
	document.body.addEventListener("mousedown", function () {
		document.body.classList.add("using-mouse");
	});

	document.body.addEventListener("keydown", function (event) {
		if (event.keyCode === 9) {
			document.body.classList.remove("using-mouse");
		}
	});
}
document.addEventListener("DOMContentLoaded", function () {
  initUsingMouse();
});







// Function to check and process h-captcha elements
function processHCaptcha() {
  // Check if h-captcha exists
  const hCaptchaElements = document.querySelectorAll('.h-captcha');
  
  if (hCaptchaElements.length === 0) {
    console.log('No h-captcha elements found');
    return;
  }

  hCaptchaElements.forEach((hCaptcha, index) => {
    // Look for input[type="text"] and textarea inside h-captcha
    const textInputs = hCaptcha.querySelectorAll('input[type="text"]');
    const textareas = hCaptcha.querySelectorAll('textarea');

    // Process text inputs
    textInputs.forEach((input, inputIndex) => {
      const uniqueId = `captcha-input-text-${index}-${inputIndex}`;
      
      // Add aria-labelledby attribute
      input.setAttribute('aria-labelledby', uniqueId);
      
      // Check if span already exists to avoid duplicates
      if (!document.getElementById(uniqueId)) {
        // Create and insert span element
        const span = document.createElement('span');
        span.className = 'visually-hidden';
        span.id = uniqueId;
        span.textContent = 'Captcha text input'; // Add descriptive text
        
        // Insert span right above the input
        input.parentNode.insertBefore(span, input);
      }
    });

    // Process textareas
    textareas.forEach((textarea, textareaIndex) => {
      const uniqueId = `captcha-input-textarea-${index}-${textareaIndex}`;
      
      // Add aria-labelledby attribute
      textarea.setAttribute('aria-labelledby', uniqueId);
      
      // Check if span already exists to avoid duplicates
      if (!document.getElementById(uniqueId)) {
        // Create and insert span element
        const span = document.createElement('span');
        span.className = 'visually-hidden';
        span.id = uniqueId;
        span.textContent = 'Captcha textarea input'; // Add descriptive text
        
        // Insert span right above the textarea
        textarea.parentNode.insertBefore(span, textarea);
      }
    });
  });

  console.log('h-captcha elements processed successfully');
}

// Function to handle dynamically added h-captcha elements
function observeDynamicHCaptcha() {
  // Create a MutationObserver to watch for dynamically added h-captcha elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Check if new nodes were added
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          // Check if the added node is an element and has/contains h-captcha
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('h-captcha')) {
              processHCaptchaElement(node);
            } else if (node.querySelector) {
              const nestedHCaptcha = node.querySelector('.h-captcha');
              if (nestedHCaptcha) {
                processHCaptchaElement(nestedHCaptcha);
              }
            }
          }
        });
      }
    });
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('Observer started for dynamic h-captcha elements');
}

// Helper function to process a single h-captcha element
function processHCaptchaElement(hCaptchaElement) {
  // Process text inputs
  const textInputs = hCaptchaElement.querySelectorAll('input[type="text"]');
  textInputs.forEach((input, index) => {
    const uniqueId = `captcha-input-text-${Date.now()}-${index}`;
    
    input.setAttribute('aria-labelledby', uniqueId);
    
    if (!document.getElementById(uniqueId)) {
      const span = document.createElement('span');
      span.className = 'visually-hidden';
      span.id = uniqueId;
      span.textContent = 'Captcha text input';
      input.parentNode.insertBefore(span, input);
    }
  });

  // Process textareas
  const textareas = hCaptchaElement.querySelectorAll('textarea');
  textareas.forEach((textarea, index) => {
    const uniqueId = `captcha-input-textarea-${Date.now()}-${index}`;
    
    textarea.setAttribute('aria-labelledby', uniqueId);
    
    if (!document.getElementById(uniqueId)) {
      const span = document.createElement('span');
      span.className = 'visually-hidden';
      span.id = uniqueId;
      span.textContent = 'Captcha textarea input';
      textarea.parentNode.insertBefore(span, textarea);
    }
  });
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  // Process existing h-captcha elements
  processHCaptcha();
  
  // Start observing for dynamically added h-captcha elements
  observeDynamicHCaptcha();
});

// If the page might load h-captcha after DOMContentLoaded,
// also run immediately in case DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    processHCaptcha();
    observeDynamicHCaptcha();
  });
} else {
  // DOM is already loaded
  processHCaptcha();
  observeDynamicHCaptcha();
}




// for accessibiilty on menu dropdown
document.addEventListener("DOMContentLoaded", () => {
  const navItems = document.querySelectorAll(".site-nav__details");
  navItems.forEach((details) => {
    const summary = details.querySelector("summary");
    const links = details.querySelectorAll(".site-nav__dropdown-link");
    // Open dropdown with ArrowDown
    summary.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        if (!details.open) {
          details.open = true;
          // details.setAttribute("aria-expanded", "true");
        }
        links[0]?.focus();
      }
    });
    links.forEach((link, index) => {
      link.addEventListener("keydown", (e) => {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          const next = links[index + 1] || links[0];
          next.focus();
        }
        if (e.key === "ArrowUp") {
          e.preventDefault();
          const prev = links[index - 1] || links[links.length - 1];
          prev.focus();
        }
        if (e.key === "Escape") {
          e.preventDefault();
          details.open = false;
          summary.focus();
        }
      });
    });
  });
});




// for mobile menu accessbility
// (function() {
//   // ==========================================================================
//   // State Management
//   // ==========================================================================
//   let activeTrap = null;
//   let currentTrigger = null;

//   // ==========================================================================
//   // Focus Trap Module
//   // ==========================================================================
//   const FocusTrap = {
//     /**
//      * Get all focusable elements within a container
//      * Enhanced to ensure we get truly focusable elements
//      */
//     getFocusableElements(container) {
//       const elements = container.querySelectorAll(
//         'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
//       );
      
//       // Filter out elements that are not actually focusable
//       return Array.from(elements).filter(el => {
//         // Check if element is visible and can receive focus
//         const style = window.getComputedStyle(el);
//         const isVisible = style.display !== 'none' && 
//                          style.visibility !== 'hidden' && 
//                          style.opacity !== '0' &&
//                          el.offsetWidth > 0 && 
//                          el.offsetHeight > 0;
        
//         // Check if element is disabled
//         const isDisabled = el.hasAttribute('disabled') || 
//                           el.hasAttribute('aria-disabled') === 'true';
        
//         return isVisible && !isDisabled;
//       });
//     },

//     /**
//      * Get current focus index in focusable elements array
//      */
//     getCurrentFocusIndex(focusableElements) {
//       return focusableElements.findIndex(el => el === document.activeElement);
//     },

//     /**
//      * Check if element is within a list item that might be interfering
//      */
//     isWithinInterferingContainer(element) {
//       // Check if element or its parent is in a list that might be capturing events
//       const listItem = element.closest('li');
//       if (listItem) {
//         // Check if the list item has any special event handlers
//         // We'll rely on focusing the actual link/button instead
//         return true;
//       }
//       return false;
//     },

//     /**
//      * Handle arrow key navigation
//      */
//     handleArrowKeys(e, focusableElements) {
//       e.preventDefault(); // Prevent default arrow key behavior (scrolling)
      
//       const currentIndex = this.getCurrentFocusIndex(focusableElements);
      
//       // If nothing is focused, focus the first element
//       if (currentIndex === -1) {
//         if (focusableElements.length > 0) {
//           focusableElements[0].focus();
//         }
//         return;
//       }

//       let nextIndex;

//       if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
//         // Move to next element
//         nextIndex = (currentIndex + 1) % focusableElements.length;
//       } 
//       else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
//         // Move to previous element
//         nextIndex = (currentIndex - 1 + focusableElements.length) % focusableElements.length;
//       }

//       // Focus the next element
//       if (nextIndex !== undefined && focusableElements[nextIndex]) {
//         const nextElement = focusableElements[nextIndex];
        
//         // Ensure the element can receive focus
//         nextElement.focus();
        
//         // For links and buttons, ensure they get proper focus styling
//         if (nextElement.tagName === 'A' || nextElement.tagName === 'BUTTON') {
//           nextElement.setAttribute('tabindex', '0');
//         }
//       }
//     },

//     /**
//      * Create focus trap handler for keyboard navigation
//      */
//     createHandler(firstElement, lastElement, allFocusable) {
//       return (e) => {
//         // Handle Escape key
//         if (e.key === 'Escape') {
//           e.preventDefault();
//           FocusTrap.closeMenu();
//           return;
//         }

//         // Handle arrow keys for navigation
//         if (e.key.startsWith('Arrow')) {
//           // Don't prevent default if it's within a textarea/input that needs arrows
//           const isInput = e.target.tagName === 'INPUT' || 
//                          e.target.tagName === 'TEXTAREA' || 
//                          e.target.isContentEditable;
          
//           if (!isInput) {
//             this.handleArrowKeys(e, allFocusable);
//           }
//           return;
//         }

//         // Handle Tab key for focus trapping
//         if (e.key !== 'Tab') return;

//         if (e.shiftKey) {
//           // Shift + Tab
//           if (document.activeElement === firstElement || 
//               (firstElement && document.activeElement === firstElement.querySelector('a, button'))) {
//             e.preventDefault();
//             lastElement.focus();
//           }
//         } else {
//           // Tab
//           if (document.activeElement === lastElement ||
//               (lastElement && document.activeElement === lastElement.querySelector('a, button'))) {
//             e.preventDefault();
//             firstElement.focus();
//           }
//         }
//       };
//     },

//     /**
//      * Close menu and cleanup focus trap
//      */
//     closeMenu() {
//       if (!currentTrigger) return;

//       currentTrigger.classList.remove('is-active');
//       currentTrigger.setAttribute('aria-expanded', 'false');

//       // Remove focus trap
//       if (activeTrap) {
//         activeTrap.destroy();
//         activeTrap = null;
//       }

//       // Return focus to trigger
//       currentTrigger.focus();
//     },

//     /**
//      * Activate focus trap
//      */
//     activate(trigger) {
//       const nav = document.querySelector('.site-header__mobile-nav');
//       if (!nav) return null;

//       const focusable = this.getFocusableElements(nav);
      
//       // Add trigger to focusable elements if it's not already included
//       if (!focusable.includes(trigger)) {
//         focusable.unshift(trigger);
//       }

//       if (!focusable.length) return null;

//       const first = focusable[0];
//       const last = focusable[focusable.length - 1];
//       const allFocusable = focusable;
//       const handler = this.createHandler(first, last, allFocusable);

//       document.addEventListener('keydown', handler);

//       return {
//         destroy() {
//           document.removeEventListener('keydown', handler);
//         }
//       };
//     },

//     /**
//      * Focus first focusable element in nav
//      */
//     focusFirstNavElement() {
//       const nav = document.querySelector('.site-header__mobile-nav');
//       if (!nav) return;

//       const focusableElements = this.getFocusableElements(nav);
      
//       if (focusableElements.length > 0) {
//         // Small delay to ensure any animations are complete
//         setTimeout(() => {
//           focusableElements[0].focus();
//         }, 100);
//       }
//     }
//   };

//   // ==========================================================================
//   // Search Visibility Module
//   // ==========================================================================
//   const SearchVisibility = {
//     /**
//      * Toggle search container visibility based on menu state
//      */
//     toggle(trigger) {
//       const searchContainer = document.querySelector('.site-header__element[data-type="search"]');
//       if (!searchContainer) return;

//       setTimeout(() => {
//         if (trigger.classList.contains("is-active")) {
//           searchContainer.style.visibility = "hidden";
//         } else {
//           searchContainer.style.visibility = "";
//         }
//       }, 0);
//     }
//   };

//   // ==========================================================================
//   // Menu Trigger Module
//   // ==========================================================================
//   const MenuTrigger = {
//     /**
//      * Handle menu state changes
//      */
//     handleStateChange(trigger, isActive) {
//       trigger.setAttribute('aria-expanded', isActive);

//       if (isActive) {
//         // Activate focus trap
//         activeTrap = FocusTrap.activate(trigger);
        
//         // Focus first nav element
//         FocusTrap.focusFirstNavElement();
//       } else {
//         // Remove focus trap
//         if (activeTrap) {
//           activeTrap.destroy();
//           activeTrap = null;
//         }
//         trigger.focus();
//         currentTrigger = null;
//       }
//     },

//     /**
//      * Handle trigger click
//      */
//     handleClick(e) {
//       const trigger = e.target.closest('.mobile-nav-trigger');
//       if (!trigger) return;

//       currentTrigger = trigger;

//       setTimeout(() => {
//         const isActive = trigger.classList.contains('is-active');
//         this.handleStateChange(trigger, isActive);
//       }, 0);

//       // Handle search visibility
//       SearchVisibility.toggle(trigger);
//     },

//     /**
//      * Initialize menu trigger listeners
//      */
//     init() {
//       document.addEventListener('click', (e) => this.handleClick(e));
//     }
//   };

//   // ==========================================================================
//   // Initialize
//   // ==========================================================================
//   MenuTrigger.init();
// })();













//  For mobile burger menu accessbility - New
document.addEventListener('click', function (e) {
  const btn = e.target.closest('button.js-toggle-submenu');
  if (!btn) return;

  // Case 1: clicked button has data-target
  const targetVal = btn.getAttribute('data-target');

  if (targetVal) {
    const parentEl = document.querySelector('[data-parent="' + CSS.escape(targetVal) + '"]');
    if (parentEl) {
      const focusBtn = parentEl.querySelector('button.js-toggle-submenu');
      if (focusBtn) focusBtn.focus();
    }
    return;
  }

  // Case 2: clicked button has NO data-target, so find closest data-parent
  const closestParent = btn.closest('[data-parent]');
  if (!closestParent) return;

  const parentVal = closestParent.getAttribute('data-parent');
  if (!parentVal) return;

  const focusBtn = document.querySelector(
    'button.js-toggle-submenu[data-target="' + CSS.escape(parentVal) + '"]'
  );

  if (focusBtn) focusBtn.focus();
});

// When clicking the button (when it's NOT active), shift mobile menu opener to first available mobile menu link
// document.addEventListener('click', function(e) {
//     // Check if clicked element matches the trigger button without .is-active class
//     const trigger = e.target.closest('button.mobile-nav-trigger:not(.is-active)');
    
//     if (trigger) {
//         // Find the first <a> tag inside mobile-nav.slide-nav__wrapper
//         const firstLink = document.querySelector('.mobile-nav.slide-nav__wrapper a');
        
//         if (firstLink) {
//             // Slight delay to ensure menu is fully opened
//             setTimeout(() => {
//                 firstLink.focus();
//             }, 100);
//         }
//     }
// });







// For new sort apply button 
// Store initial value - use a more robust approach
let initialSortValue = null;

// Function to initialize or reinitialize the sort functionality
function initSortChangeDetection() {
  const selectElement = document.querySelector('select#SortBy');
  const applyButton = document.querySelector('button#SortByApplyBtn');
  
  if (selectElement) {
    // Update initial value if it's a new instance
    initialSortValue = selectElement.value;
    
    // Remove any existing event listeners to prevent duplicates
    // We'll use a namespaced event or store the handler reference
    if (selectElement._sortChangeHandler) {
      selectElement.removeEventListener('change', selectElement._sortChangeHandler);
    }
    
    // Create the handler function
    const handler = function() {
      const currentValue = selectElement.value;
      
      if (applyButton) {
        if (currentValue !== initialSortValue) {
          applyButton.classList.add('sc-sort-changed');
        } else {
          applyButton.classList.remove('sc-sort-changed');
        }
      }
    };
    
    // Store handler reference for cleanup
    selectElement._sortChangeHandler = handler;
    
    // Attach the event listener
    selectElement.addEventListener('change', handler);
    
    // Initial check in case value was changed programmatically
    handler();
  }
}

// Function to reset initial value (call after applying sort)
function resetSortInitialValue() {
  const selectElement = document.querySelector('select#SortBy');
  if (selectElement) {
    initialSortValue = selectElement.value;
    const applyButton = document.querySelector('button#SortByApplyBtn');
    if (applyButton) {
      applyButton.classList.remove('sc-sort-changed');
    }
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initSortChangeDetection);

// Setup a MutationObserver to detect when the select element is replaced
function observeSortElement() {
  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check if the select#SortBy was added or removed
      if (mutation.type === 'childList') {
        const selectExists = document.querySelector('select#SortBy');
        
        // If the select element exists but doesn't have our handler attached
        if (selectExists && !selectExists._sortChangeHandler) {
          initSortChangeDetection();
        }
      }
    });
  });
  
  observer.observe(targetNode, config);
}

// Start observing for dynamic content changes
if (document.body) {
  observeSortElement();
}



// Desktop-only Instagram link modifier - to remove Redundant link score issue on WAVE tool
if (window.innerWidth >= 1024) {
  const modifyLinks = () => {
    document.querySelectorAll('a.instafeed-fullname[href="https://www.instagram.com/txhillcountryoliveoil/"]').forEach(link => {
      if (link.hasAttribute('href') && !link.hasAttribute('data-modified')) {
        const url = link.href;
        link.removeAttribute('href');
        link.setAttribute('onclick', `window.location.href='${url}'; return false;`);
        link.setAttribute('data-modified', 'true');
        link.style.cursor = 'pointer';
        link.setAttribute('role', 'button');
        link.setAttribute('tabindex', '0');
        link.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.location.href = url;
          }
        });
      }
    });
  };
  
  // Initial run
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', modifyLinks) : modifyLinks();
  
  // Watch for dynamic content
  new MutationObserver(mutations => {
    if (mutations.some(m => m.addedNodes.length)) modifyLinks();
  }).observe(document.body, { childList: true, subtree: true });
}







// focus to the last interacted checkbox after filter checkbox used and ajax loads the filter result
(function() {
    let lastInteractedCheckboxId = null;
    let lastInteractedCheckboxValue = null;
    let logTimeout = null;
    
    // Generate a unique identifier for the checkbox
    function getCheckboxIdentifier(checkbox) {
        const attrs = {
            id: checkbox.id || null,
            name: checkbox.name || null,
            value: checkbox.value || null,
            type: checkbox.type
        };
        
        // Create a unique key based on available attributes
        if (attrs.id) return `id:${attrs.id}`;
        if (attrs.name && attrs.value) return `name:${attrs.name}|value:${attrs.value}`;
        if (attrs.name) return `name:${attrs.name}`;
        
        // Use dataset as fallback
        if (checkbox.dataset.checkboxId) return `data:${checkbox.dataset.checkboxId}`;
        
        // Generate a stable selector based on position
        const selector = getStableSelector(checkbox);
        return `selector:${selector}`;
    }
    
    function getStableSelector(element) {
        let path = [];
        let current = element;
        
        while (current && current !== document.body) {
            if (current.id) {
                path.unshift(`#${current.id}`);
                break;
            }
            if (current.className && typeof current.className === 'string') {
                const classes = current.className.trim().split(/\s+/).join('.');
                if (classes) {
                    path.unshift(`${current.tagName.toLowerCase()}.${classes}`);
                } else {
                    path.unshift(current.tagName.toLowerCase());
                }
            } else {
                path.unshift(current.tagName.toLowerCase());
            }
            current = current.parentElement;
        }
        
        return path.join(' > ');
    }
    
    function findCheckboxByIdentifier(identifier) {
        if (!identifier) return null;
        
        if (identifier.startsWith('id:')) {
            const id = identifier.substring(3);
            return document.getElementById(id);
        }
        
        if (identifier.includes('|')) {
            const [namePart, valuePart] = identifier.split('|');
            const name = namePart.replace('name:', '');
            const value = valuePart.replace('value:', '');
            const checkboxes = document.querySelectorAll(`input[type="checkbox"][name="${name}"]`);
            for (let checkbox of checkboxes) {
                if (checkbox.value === value) {
                    return checkbox;
                }
            }
        }
        
        if (identifier.startsWith('name:')) {
            const name = identifier.substring(5);
            return document.querySelector(`input[type="checkbox"][name="${name}"]`);
        }
        
        if (identifier.startsWith('data:')) {
            const dataId = identifier.substring(5);
            return document.querySelector(`input[type="checkbox"][data-checkbox-id="${dataId}"]`);
        }
        
        if (identifier.startsWith('selector:')) {
            const selector = identifier.substring(9);
            try {
                return document.querySelector(selector);
            } catch(e) {
                return null;
            }
        }
        
        return null;
    }
    
    function attachCheckboxListeners() {
        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        
        checkboxes.forEach(checkbox => {
            checkbox.removeEventListener('click', checkboxClickHandler);
            checkbox.removeEventListener('change', checkboxChangeHandler);
            
            checkbox.addEventListener('click', checkboxClickHandler);
            checkbox.addEventListener('change', checkboxChangeHandler);
        });
    }
    
    function checkboxClickHandler(event) {
        const checkbox = event.target;
        lastInteractedCheckboxId = getCheckboxIdentifier(checkbox);
        lastInteractedCheckboxValue = checkbox.checked;
        scheduleLogAndFocus();
    }
    
    function checkboxChangeHandler(event) {
        const checkbox = event.target;
        lastInteractedCheckboxId = getCheckboxIdentifier(checkbox);
        lastInteractedCheckboxValue = checkbox.checked;
        scheduleLogAndFocus();
    }
    
    function scheduleLogAndFocus() {
        if (logTimeout) clearTimeout(logTimeout);
        
        logTimeout = setTimeout(() => {
            focusAndLogLastCheckbox();
        }, 1000);
    }
    
    function focusAndLogLastCheckbox() {
        if (!lastInteractedCheckboxId) return;
        
        const currentCheckbox = findCheckboxByIdentifier(lastInteractedCheckboxId);
        
        if (currentCheckbox && document.body.contains(currentCheckbox)) {
            // Scroll to the checkbox if needed
            currentCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
            
            // Set focus
            setTimeout(() => {
                currentCheckbox.focus({ preventScroll: true });
                addFocusVisualFeedback(currentCheckbox);
            }, 100);
            
            // Console logging
            console.group('🎯 AJAX-Safe Checkbox Focus');
            console.log('Element:', currentCheckbox);
            console.table({
                'ID': currentCheckbox.id || '(none)',
                'Name': currentCheckbox.name || '(none)',
                'Value': currentCheckbox.value || '(none)',
                'Checked': currentCheckbox.checked,
                'Focus Set': '✓',
                'After AJAX': '✓'
            });
            console.groupEnd();
        } else {
            console.log('⏳ Waiting for checkbox to appear after AJAX reload...');
            // Retry after a short delay if not found
            setTimeout(() => {
                const retryCheckbox = findCheckboxByIdentifier(lastInteractedCheckboxId);
                if (retryCheckbox) {
                    retryCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    setTimeout(() => {
                        retryCheckbox.focus({ preventScroll: true });
                        addFocusVisualFeedback(retryCheckbox);
                        console.log('✅ Checkbox found and focused on retry');
                    }, 100);
                }
            }, 500);
        }
    }
    
    function addFocusVisualFeedback(element) {
        if (!element) return;
        
        const originalOutline = element.style.outline;
        const originalBoxShadow = element.style.boxShadow;
        
        element.style.outline = '3px solid #4CAF50';
        element.style.boxShadow = '0 0 0 3px rgba(76, 175, 80, 0.3)';
        
        setTimeout(() => {
            if (element && document.body.contains(element)) {
                element.style.outline = originalOutline;
                element.style.boxShadow = originalBoxShadow;
            }
        }, 800);
    }
    
    // Public API for AJAX completion
    window.checkboxTracker = {
        refresh: function() {
            attachCheckboxListeners();
            focusAndLogLastCheckbox();
        },
        getLastCheckbox: function() {
            return findCheckboxByIdentifier(lastInteractedCheckboxId);
        }
    };
    
    // MutationObserver for DOM changes
    const observer = new MutationObserver((mutations) => {
        let hasCheckboxChanges = false;
        
        for (let mutation of mutations) {
            if (mutation.addedNodes.length) {
                for (let node of mutation.addedNodes) {
                    if (node.nodeType === 1) {
                        if (node.matches && node.matches('input[type="checkbox"]')) {
                            hasCheckboxChanges = true;
                            break;
                        }
                        if (node.querySelectorAll && node.querySelectorAll('input[type="checkbox"]').length > 0) {
                            hasCheckboxChanges = true;
                            break;
                        }
                    }
                }
            }
        }
        
        if (hasCheckboxChanges) {
            setTimeout(() => {
                attachCheckboxListeners();
                focusAndLogLastCheckbox();
            }, 200);
        }
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Initial setup
    attachCheckboxListeners();
    
    // Custom event for AJAX completion
    document.addEventListener('ajaxComplete', function() {
        setTimeout(() => {
            attachCheckboxListeners();
            focusAndLogLastCheckbox();
        }, 100);
    });
    
    console.log('✅ AJAX-compatible checkbox tracker initialized');
})();

// Usage in your AJAX callback:
// After your AJAX reload completes, call:
// document.dispatchEvent(new Event('ajaxComplete'));
// OR
// window.checkboxTracker.refresh();











// Function to update aria-level from 5 to 3
function updateAriaLevel(element) {
  if (element.getAttribute('aria-level') === '5') {
    element.setAttribute('aria-level', '3');
    console.log('Updated aria-level to 3 for:', element);
  }
}

// Function to process all current matching elements
function processExistingElements() {
  const elements = document.querySelectorAll(
    '.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-product-title[aria-level="5"]'
  );
  
  elements.forEach(updateAriaLevel);
}

// Function to set up a MutationObserver to watch for dynamically added elements
function setupMutationObserver() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Check for added nodes
      mutation.addedNodes.forEach((node) => {
        // If the added node is an element node
        if (node.nodeType === 1) {
          // Check if the node itself matches
          if (node.matches && node.matches('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-product-title[aria-level="5"]')) {
            updateAriaLevel(node);
          }
          
          // Check for matching elements within the added node
          if (node.querySelectorAll) {
            const matchingElements = node.querySelectorAll(
              '.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-product-title[aria-level="5"]'
            );
            matchingElements.forEach(updateAriaLevel);
          }
        }
      });
      
      // Also check for attribute changes in case the aria-level is set after element creation
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'aria-level' &&
          mutation.target.matches && 
          mutation.target.matches('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-product-title')) {
        updateAriaLevel(mutation.target);
      }
    });
  });
  
  // Start observing the entire document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-level']
  });
  
  return observer;
}

// Initialize
function init() {
  // Process any existing elements
  processExistingElements();
  
  // Set up observer for future dynamically added elements
  setupMutationObserver();
  
  console.log('Aria-level updater initialized');
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}







// Function to update aria attribute based on class presence for mobile menu trigger
function updateAriaAttribute(element) {
  const hasActiveClass = element.classList.contains('is-active');
  element.setAttribute('aria-expanded', hasActiveClass);
  // You can also update other aria attributes if needed
  // element.setAttribute('aria-label', hasActiveClass ? 'Close menu' : 'Open menu');
}

// Find the mobile-nav-trigger element
const mobileNavTrigger = document.querySelector('.mobile-nav-trigger');

if (mobileNavTrigger) {
  // Set initial state
  updateAriaAttribute(mobileNavTrigger);
  
  // Create a MutationObserver to watch for class changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        updateAriaAttribute(mobileNavTrigger);
      }
    });
  });
  
  // Start observing the element for class attribute changes
  observer.observe(mobileNavTrigger, {
    attributes: true,
    attributeFilter: ['class']
  });
}